import {BaseLayerDeck} from './baseLayerDeck';


export abstract class BaseLayerClusterGeoJSONDeck extends BaseLayerDeck {
    protected constructor(id) {
        super(id);
    }

    init(map, visible, underLayerId = null, loadedCallback: (layer) => void) {
        map.addToLoading(this);
        this.getDataLayer().then((layers) => {

            layers.forEach(l => {
                const layer = this.layers[l.id];
                const _data = {data: l.data};
                this.layers[l.id] = layer.clone(_data);
            });
            super.init(map, visible, underLayerId, loadedCallback);
            map.removeFromLoading();
        });
    }

    abstract getDataLayer();

    getEmptySource() {
        return {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Point',
                        coordinates: []
                    }
                }
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/common/layers/baseLayerClusterGeoJSONDeck.ts